export default {
  SET_MENU(state, menu) {
    state.menu = menu
  },
  SET_MENU_TABLE(state, menus) {
    state.table_menu = menus
  },
  SET_ROL_TABLE(state, rols) {
    state.table_rol = rols
  },
  SET_EMPRESA_TABLE(state, companies) {
    state.table_empresa = companies
  },
  SET_USER_TABLE(state, users) {
    state.table_user = users
  },
}
